export const LOGISTICS_OPAD_RULES: string = 'rules';
export const LOGISTICS_OPAD_RULES_DETAIL: string = 'rule-detail';
export const LOGISTICS_OPAD_IMPORT_RULES: string = 'import-rules';
export const LOGISTICS_OPAD_HISTORY_RULES: string = 'history-rules';

export const LOGISTICS_OPAD_TRANSPORTER: string = 'transporter';
export const LOGISTICS_OPAD_TRANSPORTER_DETAIL: string = 'transporter-detail';
export const LOGISTICS_OPAD_SEGMENTS: string = 'segments';
export const LOGISTICS_OPAD_CHANNEL_SEGMENTS: string = 'channel-segments';
export const LOGISTICS_OPAD_IMPORT_SEGMENTS: string = 'import-segments';
export const LOGISTICS_OPAD_HISTORY_SEGMENTS: string = 'history-segments';

export const LOGISTICS_OPAD_CHANNEL: string = 'channels';
export const LOGISTICS_OPAD_CHANNEL_DETAIL: string = 'channel-detail';

export const LOGISTICS_OPAD_PENALTIES: string = 'penalties';

export const LOGISTICS_OPAD_ASR_LIST: string = 'asr-list';
export const LOGISTICS_OPAD_ASR_LIST_DETAIL: string = 'detail';

export const LOGISTICS_OPAD_REQUEST_LIST: string = 'request-list';
export const LOGISTICS_OPAD_REQUEST_LIST_VEHICLE_DETAIL: string = 'vehicle-detail';

export const LOGISTICS_OPAD_SETTINGS: string = 'Configurations';
